import { addDays, subDays } from "date-fns";
import { formatDateWithDayOfWeek } from "../../utils/dateHelper";
import type { YadoPlan } from "../types";
import i18n from "../../i18n";

type YadoPlanCancellationPolicyProps = {
  plan: YadoPlan;
  checkinDate: Date;
}

const YadoPlanCancellationPolicy: React.FC<YadoPlanCancellationPolicyProps> = ({ plan, checkinDate }) => {
  const lastCancellationPolicy = plan.cancellation_policies.sort((a, b) => { return a.remaining_days - b.remaining_days })[0];
  return (
    <>
      {plan.cancellation_policies.length > 0 ? (
        <>
          <div className="bg-light rounded p-1">
            <table className="table table-sm table-border-top-0 w-100 mb-0">
              <tbody>
                {plan.cancellation_policies.sort((a, b) => { return b.remaining_days - a.remaining_days }).map((policy) => (
                  <tr key={`yado_cancellation_policy_${policy.remaining_days}`}>
                    <td>{i18n.t('accommodations.before_date_on_japan_standard_time', { date: formatDateWithDayOfWeek(subDays(checkinDate, policy.remaining_days))})}</td>
                    <td className="text-right">
                      { policy.penalty_rate === 0 ? i18n.t('accommodations.free_cancellation') : `${policy.penalty_rate} %`}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td>{i18n.t('accommodations.from_date_on_japan_standard_time', { date: formatDateWithDayOfWeek(subDays(checkinDate, (lastCancellationPolicy.remaining_days - 1)))})}</td>
                  <td className="text-right">
                    {i18n.t('accommodations.cancellation_fee_100')}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="text-sm my-2" style={{ whiteSpace: 'pre-line' }}>
            {i18n.t('accommodations.cancel_note')}
          </p>
        </>
      ) : (
        <>
          <div className="bg-light rounded p-1">
            <table className="table table-sm table-border-top-0 w-100 mb-0">
              <tbody>
                <tr>
                  <td>{i18n.t('accommodations.before_date_on_japan_standard_time', { date: formatDateWithDayOfWeek(new Date(plan.free_cancellation_deadline)) })}</td>
                  <td className="text-right">{i18n.t('accommodations.free_cancellation')}</td>
                </tr>
                <tr>
                  <td>{i18n.t('accommodations.from_date_on_japan_standard_time', { date: formatDateWithDayOfWeek(addDays(new Date(plan.free_cancellation_deadline), 1)) })}</td>
                  <td className="text-right">{i18n.t('accommodations.cancellation_fee_100')}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="text-sm my-2" style={{ whiteSpace: 'pre-line' }}>
            {i18n.t('accommodations.cancel_note')}
          </p>
        </>
      )}
    </>
  )
}

export default YadoPlanCancellationPolicy;
